import { Context } from '../domain/Context'
import { Observable } from 'rxjs'

export abstract class ContextService {
  abstract context(): Observable<Context>
}
